import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/root/project/styles.scss';export default {
  "project": "_project_lakov_1",
  "main": "_main_lakov_6",
  "header": "_header_lakov_20",
  "projectPopup": "_projectPopup_lakov_29",
  "iconBox": "_iconBox_lakov_33",
  "icon": "_icon_lakov_33",
  "folderIcon": "_folderIcon_lakov_53",
  "openedIcon": "_openedIcon_lakov_61",
  "popupIcon": "_popupIcon_lakov_71",
  "projectPopupMain": "_projectPopupMain_lakov_77",
  "row": "_row_lakov_82",
  "avatar": "_avatar_lakov_89",
  "col": "_col_lakov_94",
  "link": "_link_lakov_103",
  "name": "_name_lakov_107",
  "deactivated": "_deactivated_lakov_116",
  "profession": "_profession_lakov_126",
  "recordList": "_recordList_lakov_131",
  "removedBadge": "_removedBadge_lakov_135"
};